module.exports = __webpack_public_path__ + "img/imagem8.1d00a65f.svg";